import React from 'react';
import { useTranslation } from 'react-i18next';

import style from './Footer.module.scss';

import { isServiceConsole } from '../../../../helpers';

function Footer() {
  const { t } = useTranslation();
  const helpUrl = isServiceConsole ? window.fromServer.env.SERVICE_CONSOLE_HELP_LINK : '/help';

  return (
    <nav className={style.mainFooter}>
      <ul>
        <li>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.yubico.com/support/terms-conditions/privacy-notice/"
            data-testid="privacy_policy"
          >
            {t('privacy_policy')}
          </a>
        </li>
        <li>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={window.fromServer.env.ACCEPTABLE_USE_LINK}
            data-testid="acceptable_use_policy"
          >
            {t('acceptable_use_policy')}
          </a>
        </li>
        <li>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.yubico.com/products/yubikey-as-a-service/contact-support/?selectForm=I+need+help+with+YubiEnterprise+Delivery"
            data-testid="contact_support"
          >
            {t('contact_support')}
          </a>
        </li>
        <li>
          <a href={helpUrl} target="_blank" rel="noreferrer" data-testid="help">
            {t('help')}
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default Footer;
